<template>
  <div class="partners">

    <h1 class="partner-heading">The world's best choose us</h1>

    <span class="partner-logos">
      <img v-for="partner in keyPartnerList" :src="getSocialImageUrl(partner)" alt="partner">
    </span>

    <!-- <h1 class="partner-heading">The world's best choose us</h1> -->
    <!-- <button class="all-partners-button" type="button" name="button">See all partners</button> -->
  </div>
</template>

<script>

// Upload more images here
// https://console.aws.amazon.com/s3/buckets/mikmak/uploads/2e88caf4-9a47-4535-96d5-6f1696e4db90/?region=us-east-1&tab=overview

export default {
  mounted() {
    // if (!window.sr) window.sr = ScrollReveal()
    // window.sr.reveal('.partners', { delay: 250, duration: 500 })
  },
  methods: {
    getSocialImageUrl(brand) {
      var images = require.context('../../../assets/brand-logos/')
      return images(`./${brand}.png`)
    }
  },
  computed: {
    partnerText() {
      return this.$store.state.partnerText
    },
    partnerList() {
      return this.$store.state.partnerList
    },
    keyPartnerList() {
      return this.$store.state.keyPartnerList
    }
  },
  watch: {}
}
</script>

<style scoped>

  .partners {
    display: block;
    margin: 120px 0;
    margin-bottom: 0px;
  }

  .partner-logos {
    text-align: center;
    display: block;
    width: 90%;
    max-width: 1000px;
    margin: 24px auto;
  }

  @media only screen and (max-width: 1000px) {
    .partners {
      margin-top: 50px;
    }
    .partner-logos {
      width: 90%;
    }
  }

  .partner-logos img {
    width: 121px;
    margin: 20px;
  }

  @media only screen and (max-width: 800px) {
    .partner-logos img {

    }
  }

  @media only screen and (max-width: 450px) {
    .partner-logos img {

    }
  }

  .partner-heading {
    font-family: "Work Sans",sans-serif;
    font-weight: normal;
    letter-spacing: 2px;
    font-size: 14px;
    margin: 0 auto;
    display: block;
    text-align: center;
    text-transform: uppercase;
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .all-partners-button {
    font-family: "Work Sans",sans-serif;
    display: block;
    margin: 24px auto;
    text-align: center;
    -webkit-appearance: none;
    /* background: #31c4a8; */
    color: white;
    /* border: 1px solid #31c4a8; */
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
    border: none;
    border-radius: 4px;
    padding: 6px 42px;
    font-size: 20px;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// PartnersHero.vue?07f558fc